<template>
  <main 
  v-if="page"
  id="content" 
  aria-labelledby="main-title"
  >
    
    <ElementHero
    v-if="test === 'a'"
    :content="page.hero"
    />
    <ElementHeroB
    v-else-if="test === 'b'"
    :content="page.hero"
    />

    <template v-if="page?.dynamic">
      <template v-for="(section, index) in page?.dynamic">
        <component 
        :is="getSectionComponent(section.collection)" 
        :sectionIndex="index"
        :sectionTotal="page?.dynamic.length"
        :content="section.item"
        />
      </template>
    </template>

  </main>
</template>

<script setup>

const route = useRoute()
const userStore = useUserStore()

const { heroTest } = storeToRefs(userStore)

const contentSections = useContentSections()

const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

const test = ref('a')

onMounted(() => {
  if (process.client && heroTest.value) {
    test.value = heroTest.value
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'test_hero_'+heroTest.value,
      })
    }
  }
})

const { getItems } = useCms()
const fields = useFields()
const { data } = await useAsyncData(
  currentLocale.value+'-page-home',
  () => getItems({
    collection: route.path.startsWith('/nz') ? 'home_nz' : 'home',
    params: {
      fields
    }
  })
)

const page = data?.value

const seo = computed(() => {
  if (page?.seo) {
    return useSeo(page.seo, route.fullPath)
  }
  return {}
})

useHead(seo)

useSchemaOrg([
  defineSoftwareApp({
    name: 'Elker',
    applicationCategory: 'BusinessApplication',
    applicationSubCategory: 'Workplace integrity platform',
    operatingSystem: 'Web, iOS, Android',
    url: 'https://elker.com',
    description: 'Speak-up and workplace integrity platform. Report, manage and investigate workplace misconduct with anonymous reporting channels, two-way secure messaging, and end-to-end case management.',
    featureList: [
      'Anonymous reporting channels across web, app, and hotline',
      'Two-way secure messaging between reporters and investigators',
      'End-to-end case management and investigation workflows',
      'Psychosocial hazard tracking and reporting',
      'Policy distribution, acknowledgement, and audit trails',
      'Role-based access controls and secure data handling',
      'Compliance reporting for whistleblower schemes and workplace integrity'
    ]
  })
])

const getSectionComponent = key => {
  return contentSections[key]
}

</script>